import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import TableRow from "./TableRow";
import classes from "./styles.module.css";

function isEmptyValue(v) {
    return v === null || v === undefined || String(v).trim() === "";
}

function addFieldError(errors, fieldKey, message) {
    // Поддержим 2 распространённых формата:
    // 1) errors как объект: { phoneNumber: "msg", ... }
    // 2) errors как массив строк: ["msg", ...]
    if (!errors) {
        return {[fieldKey]: message};
    }

    if (Array.isArray(errors)) {
        // Не ломаем текущий формат, если он уже массив
        return [...errors, message];
    }

    // Если объект — добавляем по ключу поля (для подсветки ячейки)
    const next = {...errors};
    if (!next[fieldKey]) {
        next[fieldKey] = message;
    }
    return next;
}

export default function Table({data, processing, requiresDocuments}) {
    const intl = useIntl();
    if (!data || data.length === 0) return null;

    const isFinStar =
        typeof requiresDocuments === "boolean"
            ? requiresDocuments
            : String(processing || "").toLowerCase() === "finstar";

    // Если FinStar — колонки документов показываем всегда
    const hasDocNumber = isFinStar || data.some((el) => el && el.row && !isEmptyValue(el.row.documentNumber));
    const hasDocDate = isFinStar || data.some((el) => el && el.row && !isEmptyValue(el.row.documentDate));

    const columns = [
        {key: "creditCard", labelId: "RegistryUpload.table.creditCard", defaultMessage: "Номер карты"},
        {key: "cardHolderRu", labelId: "RegistryUpload.table.cardHolderRu", defaultMessage: "Имя держателя карты"},
        {key: "amount", labelId: "RegistryUpload.table.amount", defaultMessage: "Сумма"},
        {key: "phoneNumber", labelId: "RegistryUpload.table.phoneNumber", defaultMessage: "Телефон"},
        ...(hasDocNumber
            ? [{
                key: "documentNumber",
                labelId: "RegistryUpload.table.documentNumber",
                defaultMessage: "Номер документа"
            }]
            : []),
        ...(hasDocDate
            ? [{key: "documentDate", labelId: "RegistryUpload.table.documentDate", defaultMessage: "Дата документа"}]
            : []),
    ];

    const normalizedData = data.map((el) => {
        const row = (el && el.row) ? el.row : {};
        let hasError = Boolean(el && el.hasError);
        let errors = el ? el.errors : undefined;

        if (isFinStar) {
            if (isEmptyValue(row.documentNumber)) {
                hasError = true;
                errors = addFieldError(
                    errors,
                    "documentNumber",
                intl.formatMessage({
                    id: "RegistryUpload.error.documentNumberRequired",
                    defaultMessage: "Номер документа обязателен для FinStar.",
                })
            );
            }

            if (isEmptyValue(row.documentDate)) {
                hasError = true;
                errors = addFieldError(
                    errors,
                    "documentDate",
                intl.formatMessage({
                    id: "RegistryUpload.error.documentDateRequired",
                    defaultMessage: "Дата документа обязательна для FinStar.",
                })
            );
            }
        }

        return {...el, row, hasError, errors};
    });

    return (
        <div className={classes.TableWrap}>
        <table className={classes.Table}>
            <thead>
            <tr>
                {columns.map((c) => (
                    <th key={c.key} className={classes.HeaderCell}>
                        <FormattedMessage id={c.labelId} defaultMessage={c.defaultMessage}/>
                    </th>
                ))}
                <th className={classes.HeadCellToggle}/>
            </tr>
            </thead>
            <tbody>
            {normalizedData.map((el, index) => (
                <TableRow
                    key={index}
                    data={el.row}
                    hasError={el.hasError}
                    errors={el.errors}
                    columns={columns}
                />
            ))}
            </tbody>
        </table>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/Components/RegistryTable/index.js